"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("title", null, "Trace Icons_1-3"), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16,22.36a3.52,3.52,0,0,1-2.53-1.05L2.91,10.75l.92-.92L14.39,20.39a2.33,2.33,0,0,0,3.22,0L28.17,9.83l.92.92L18.53,21.31A3.52,3.52,0,0,1,16,22.36Z"
})));
module.exports = exports.default;